import USMapState from "../../model/geographic/USMapState";
import * as d3 from "d3";
import {USMapType} from "../../model/geographic/USMapType";
import {StateElectionDataEntry} from "../../model/data/StateElectionDataEntry";
import {FeatureCollection, Geometry} from "geojson";

const BASE_PATH = process.env.REACT_APP_BASE_PATH || '';

export const fetchData = async () => {
    const response = await fetch(`${BASE_PATH}/data/states-10m.json`);
    return await response.json();
};

export const normalizeStateName = (name: string): string => {
    return name.replace(/\s/g, '');
};

export function circlePath(x: number, y: number, r: number): string {
    return `M ${x - r}, ${y}
            a ${r},${r} 0 1,0 ${2 * r},0
            a ${r},${r} 0 1,0 ${-2 * r},0
            Z`;
}

export function getPath(d: any, mapState: USMapState, path: d3.GeoPath): string {
    if (mapState.mapType === USMapType.GEOGRAPHIC) {
        return path(d.largestGeometry) || '';
    } else {
        const normalizedStateName = normalizeStateName(d.properties.name) as keyof StateElectionDataEntry;
        const radius = mapState.getCircleRadius(normalizedStateName);
        return circlePath(d.x, d.y, radius);
    }
}

export function prepareStateFeatures(usGeoData: FeatureCollection<Geometry>) {
    return usGeoData.features.map((d: any) => {
        const geometries = d.geometry.type === 'MultiPolygon' ? d.geometry.coordinates : [d.geometry.coordinates];

        const largestGeometry = geometries.reduce((largest: any, current: any) => {
            return d3.geoArea({type: 'Polygon', coordinates: current}) > d3.geoArea({
                type: 'Polygon',
                coordinates: largest
            }) ? current : largest;
        }, geometries[0]);

        const projection = d3.geoAlbersUsa().scale(1000).translate([480, 250]);
        const path = d3.geoPath().projection(projection);
        const pathData = path({...d, geometry: {type: 'Polygon', coordinates: largestGeometry}}) || '';
        const numPoints = pathData.split(/[MLA]/).length - 1;
        return {
            ...d,
            centroid: path.centroid({...d, geometry: {type: 'Polygon', coordinates: largestGeometry}}),
            numPoints: numPoints,
            pathData: pathData,
            largestGeometry: {type: 'Polygon', coordinates: largestGeometry}
        };
    });
}